module.exports = __webpack_public_path__ + "img/luxcaddy-bg-pattern.eb078536.jpg";